import React, { Component } from 'react';
import Link from 'redux-first-router-link';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import cartAnalytics from './cartAnalytics';
import { changeQuantity, changeSize, updateKlarna, updatePaymentMethod, addToBag, retrieveProductCache } from '../../actions/checkout';
import Price from '../Product/Price';
import { translate, translateObjectData, prefix } from '../../utils/locale';
import { deepClone } from '../../utils/object';
import s from './CartItems.scss';

class CartItems extends Component {
	updateQuantityHandler = (e) => {
		const { checkout, currentPage, setup } = this.props;
		const $link = e.currentTarget;
		const itemId = $link.closest('.checkoutItem').dataset.item;
		const itemObj = checkout.selection.items.reduce((acc, item) => ({ ...acc, ...(item.item === itemId ? item : {}) }), {});
		const cachedItem = Object.keys(checkout.selectionCache).filter((scItem) => scItem === itemId.split('-')[0]).map((scItem) => checkout.selectionCache[scItem])[0];
		const action = $link.value;
		let quantity = itemObj.quantity;
		let analyticsQuantity = 1;

		switch (action) {
			case 'increase':
				quantity += 1;
				break;
			case 'decrease':
				quantity -= 1;
				break;
			case 'remove':
				quantity = 0;
				analyticsQuantity = itemObj.quantity;
				break;
			default:
				break;
		}

		this.props.changeQuantity(itemObj, quantity)
			.then((response) => {
				if (currentPage === 'selection') {
					this.props.updateKlarna();
					this.props.updatePaymentMethod();
				}
				if (response.data.selection.items.length === 0) this.props.toggleCartHandler(false);

				cartAnalytics(cachedItem, itemObj, setup, false, cachedItem.category, response.data.selection, checkout.listItemCache, ['remove', 'decrease'].indexOf(action) !== -1, analyticsQuantity);

				return response;
			}).catch((err) => console.log('DEBUG: quantity did not change', err));
	}

	setQuantityHandler = (id, quantity) => {
		const { checkout, currentPage } = this.props;
		const itemId = id.replace('updateQuantity-', '');
		const itemObj = checkout.selection.items.reduce((acc, item) => ({ ...acc, ...(item.item === itemId ? item : {}) }), {});

		this.props.changeQuantity(itemObj, quantity)
			.then(() => {
				if (currentPage === 'selection') {
					this.props.updateKlarna();
					this.props.updatePaymentMethod();
				}
				return null;
			}).catch((err) => console.log('DEBUG: quantity did not change', err));
	}

	render() {
		const { checkout, currentPage, setup, productCache, items = [], toggleCartHandler } = this.props;
		if (!productCache?.[setup.market]?.[setup.pricelist]) {
			this.props.retrieveProductCache();
			return null;
		}
		const { products = {} } = productCache?.[setup.market]?.[setup.pricelist];
		let currentItems = [];
		if (checkout?.selection?.items) currentItems = deepClone(checkout.selection.items);
		if (items.length > 0) currentItems = deepClone(items);
		const applyFinalSale = translate(setup, 'finalSalePricelistIds').split(',').indexOf(setup.pricelist) !== -1;

		const lineItems = currentItems.map((item) => {
			const productId = typeof item === 'object' ? item.item.slice(0, item.item.indexOf('-')) : item;
			const itemCache = checkout.selectionCache[productId] || products[productId] || {};
			const itemDetails = translateObjectData(setup, itemCache);
			if (item.quantity === 0 || !itemDetails) return null;
			const selectedSizeDetail = itemDetails.sizes.filter((size) => size.item === item.item)[0] || {};

			const price = {};
			Object.keys(item).forEach((priceItem) => {
				if (priceItem.indexOf('price') === 0) price[priceItem.replace('priceEach', 'price')] = item[priceItem];
			});

			return (
				<div key={item.item} className={[s.cartItem, 'checkoutItem', (currentPage === 'receipt' ? s.cartItem__receipt : null)].join(' ')} data-item={item.item}>
					<Link className={s.cartItem_image} to={prefix(setup, (itemDetails.category ? itemDetails.category : itemDetails.canonicalUri))} onClick={toggleCartHandler}>
						{ itemDetails?.image && itemDetails.image.length > 0 ? <img src={itemDetails?.image[0].replace(/\.(\w+)$/, '-200x.$1')} alt={itemDetails.name} /> : null }
					</Link>
					<div className={s.cartItem_info}>
						<div className={s.cartItem_info_name}>
							<span>{ itemDetails.name }</span>
							<span><Price price={price} cart /></span>
						</div>
						<div className={s.cartItem_info_details}>
							{ itemDetails.variantName && <span>{ translate(setup, 'filterColor') }: <strong>{ itemDetails.variantName }</strong></span> }
							{ item.size !== '' && <span>{ translate(setup, 'size') }: <strong>{ item.size }</strong></span> }
							{ itemDetails.productStatus_finalSale && applyFinalSale && <span className={s.cartItem_info_details_finalSale}><strong>{ translate(setup, 'finalSale') }</strong></span> }
						</div>
						<div className={s.cartItem_info_adjust}>
							<div className={s.cartItem_info_adjust_quantity}>
								{ selectedSizeDetail?.stock <= 3 && currentPage !== 'receipt' && <span className={s.cartItem_info_adjust_fewLeft}><span>{ translate(setup, 'cartLeft').replace('%amount%', selectedSizeDetail.stock) }</span></span> }
								<span className={s.cartItem_info_adjust_title}>{ `${translate(setup, 'quantity')}:` }</span>
								{
									currentPage !== 'receipt' ? (
										<>
											<button className={[s.cartItem_info_adjust_button, s.cartItem_info_adjust_button__decrease].join(' ')} type="button" value="decrease" onClick={this.updateQuantityHandler}>
												<svg width="9" height="1" viewBox="0 0 9 1" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M9.09963e-07 1L2.91663 1L9 1L9 3.33632e-05L2.93963 3.30983e-05L9.53674e-07 -3.93402e-07L9.09963e-07 1Z" fill="black" />
												</svg>
											</button>
											<span className={s.cartItem_info_adjust_quantity_amount}>{ item.quantity }</span>
											<button className={[s.cartItem_info_adjust_button, s.cartItem_info_adjust_button__increase].join(' ')} type="button" value="increase" onClick={this.updateQuantityHandler}>
												<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M5 9V1.19209e-07L4.00003 0L4 9H5Z" fill="black" />
													<path d="M0 5L9 5V4.00003L4.37115e-08 4L0 5Z" fill="black" />
												</svg>
											</button>
										</>
									) : <span className={s.cartItem_info_adjust_quantity}>{ item.quantity }</span>
								}
							</div>
							{
								currentPage !== 'receipt' && (
									<button className={[s.cartItem_info_adjust_button, s.cartItem_info_adjust_button__remove].join(' ')} type="button" value="remove" onClick={this.updateQuantityHandler}>
										{ translate(setup, 'remove') }
										<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M1.2011 9L9 1.09436L7.92042 0L0.151003 7.87575L1.2011 9Z" fill="black" />
											<path d="M7.7989 9L0 1.09436L1.07958 0L8.849 7.87575L7.7989 9Z" fill="black" />
										</svg>
									</button>
								)
							}
						</div>
					</div>
				</div>
			);
		});

		return (
			<div className={s.cartItems}>
				{ lineItems.filter((lineItem) => !!lineItem).length > 0 ? lineItems : <span>{ translate(setup, 'noItems') }</span> }
			</div>
		);
	}
}

const mapState = ({ environment, checkout, productCache }, { currentPage, items }) => ({
	setup: environment.setup,
	items,
	checkout,
	productCache,
	currentPage,
});

export default hot(module)(connect(mapState, { changeQuantity, changeSize, updateKlarna, updatePaymentMethod, addToBag, retrieveProductCache })(CartItems));
